/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    state.SubscriptionPeriods.unshift(item)
  },
  SET_SubscriptionPeriods(state, SubscriptionPeriods) {
    debugger;
    try {
    
      state.SubscriptionPeriods = SubscriptionPeriods;
     
    } catch (error) {
      console.error("Failed to parse SubscriptionPeriods data JSON:", error);
      state.SubscriptionPeriods = [];
    }
  },
  UPDATE_SubscriptionPeriod(state, SubscriptionPeriod) {
    debugger
    const SubscriptionPeriodIndex = state.SubscriptionPeriods.findIndex((p) => p.Id == SubscriptionPeriod.Id)
    Object.assign(state.SubscriptionPeriods[SubscriptionPeriodIndex], SubscriptionPeriod)
  },
  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.SubscriptionPeriods.findIndex((p) => p.ID == itemId)
      state.SubscriptionPeriods.splice(ItemIndex, 1)
  },
}
